/**
 * Progress shown at both the task-type (list card) and recommendations (detail
 * footer) levels combines two sources:
 * - published baseline: recommendations already actioned in prior sessions,
 *   read from the by-type summary (list) or the query `progress` (detail).
 * - local unpublished: accept/reject/override edits held in the store.
 *
 * Both are expressed as "actioned out of total", so the two levels agree.
 */
export const clampPercent = (value: number): number =>
  Math.min(100, Math.max(0, value));

export const computeProgressPercent = (
  actionedCount: number,
  totalCount: number,
): number =>
  totalCount <= 0 ? 0 : clampPercent((actionedCount / totalCount) * 100);

/**
 * Combined actioned count = published baseline + local unpublished, clamped to
 * the total so stale local edits can never push it past 100%.
 */
export const combineActionedCount = (
  publishedActionedCount: number,
  localActionedCount: number,
  totalCount: number,
): number => Math.min(totalCount, publishedActionedCount + localActionedCount);
